module.exports = __webpack_public_path__ + "img/icons BFr_10.9a6d76b4.png";